import { useFormContext } from "react-hook-form";
import {useEffect, useRef} from "react";
import {useSessionContext} from "../../../../context/SessionContext";
import {PARAMETER_RESTORE_FORM_DATA} from "../../../../pages/config/settings";
import {PRODUCT_QUANTITY} from "./constants";

/**
 * Sets a preset value for a form field if it's not already set
 *
 * @param fieldName The name of the form field.
 * @param presetValue The preset value to set.
 */
export const useSetPresetValue = <T,>(
    fieldName: string,
    presetValue: T | undefined
) => {
    const { getValues, setValue } = useFormContext();
    const currentValue = getValues(fieldName);
    const session = useSessionContext();

    const shouldRestoreFormDataRef = useRef(session.getFromSession(PARAMETER_RESTORE_FORM_DATA) === "true");

    useEffect(() => {
        // If restoreFormData is true and the field is PRODUCT_QUANTITY, don't set any default values
        if (shouldRestoreFormDataRef.current && fieldName === PRODUCT_QUANTITY) {
            return;
        }

        if (presetValue !== undefined && currentValue !== presetValue) {
            setValue(fieldName, presetValue);
        }
    }, [presetValue, currentValue, setValue, fieldName]);
};
